import { DATES } from "@/data";

export default function Tour() {
  return (
    <div data-testid="tour-list" className="max-w-2xl mx-auto">
      {DATES.map((d, i) => (
        <div key={`${d.day}-${d.location}`}>
          <div className="flex gap-6 sm:gap-10 py-8 sm:py-10 px-2 sm:px-6 items-center" data-testid={`tour-date-${i}`}>
            <div className="flex flex-col items-center shrink-0 w-[96px] sm:w-[130px]">
              <span className="font-light text-[72px] sm:text-[96px] leading-none tracking-tight">{d.day}</span>
              <span className="text-sm sm:text-lg tracking-[0.08em] mt-2">{d.month}</span>
            </div>
            <div className="flex-1">
              <p className="text-3xl sm:text-5xl font-light leading-tight">{d.location}</p>
              {d.tickets ? (
                <a href={d.tickets} target="_blank" rel="noopener noreferrer" data-testid={`get-tickets-${i}`}
                  className="inline-block mt-6 border border-white px-4 py-1.5 text-xl sm:text-2xl tracking-[0.04em] font-light hover:bg-white hover:text-black transition-colors duration-300">
                  GET TICKETS
                </a>
              ) : (
                <p className="mt-6 text-[#6b6f76] text-sm tracking-[0.2em]">TICKETS SOON</p>
              )}
            </div>
          </div>
          {i < DATES.length - 1 && <div className="tour-divider" />}
        </div>
      ))}
    </div>
  );
}
